import React from "react";

function StepFourteen({ formData, onNext, isSubmitting }) {
    const isCurrentlySubmitting = isSubmitting;
 console.log(isCurrentlySubmitting);
  const renderField = (label, value, isFile = false) => (
    <div className="mb-2">
      <strong>{label}:</strong>{" "}
      {value ? (isFile ? `${value} (attached)` : value.toString()) : "—"}
    </div>
  );

  const renderSection = (title, fields) => (
    <div className="mb-4">
      <h6 className="mb-3 border-bottom pb-2">{title}</h6>
      {fields}
    </div>
  );

  return (
    <div className="step-form">
      <h6 className="mb-4">Review Your Submission</h6>

      <div className="bg-light p-4 rounded border">
        {/* ID Verification Section */}
        {renderSection(
          "ID Verification & Right to Work",
          <>
            {renderField(
              "UK Passport Holder",
              formData.hasUKPassport === "yes" ? "Yes" : "No"
            )}
            {formData.hasUKPassport === "yes" &&
              renderField("Passport File", formData.passportFile, true)}
            {formData.hasUKPassport === "no" && (
              <>
                {renderField(
                  "Residency Document",
                  formData.residencyFile,
                  true
                )}
                {renderField("ID Card", formData.idCardFile, true)}
                {renderField("Work Visa", formData.workVisaFile, true)}
              </>
            )}
          </>
        )}

        {/* Emergency Contact Section */}
        {renderSection(
          "Emergency Contact Details",
          <>
            {renderField("First Name", formData.kinName)}
            {renderField("Last Name", formData.kinLName)}
            {renderField("Address", formData.kinAddress)}
            {renderField("Mobile", formData.kinMobile)}
            {renderField("Email", formData.kinEmail)}
          </>
        )}

        {/* DBS Information Section */}
        {renderSection(
          "DBS Information",
          <>
            {renderField(
              "Valid DBS Certificate",
              formData.hasDBS === "yes" ? "Yes" : "No"
            )}
            {formData.hasDBS === "yes" &&
              renderField("DBS Certificate", formData.dbsFile, true)}
            {renderField(
              "DBS Update Service Registered",
              formData.dbsUpdateRegistered === "yes" ? "Yes" : "No"
            )}
            {formData.dbsUpdateRegistered === "yes" &&
              renderField("Update Service Details", formData.dbsUpdateDetails)}
          </>
        )}

        {/* Professional Registration Section */}
        {renderSection(
          "Professional Registration",
          <>
            {renderField(
              "Professionally Registered",
              formData.isRegistered === "yes" ? "Yes" : "No"
            )}
            {formData.isRegistered === "yes" && (
              <>
                {renderField("Regulatory Body", formData.regulatoryBody)}
                {renderField("Membership Number", formData.membershipNumber)}
                {renderField("Expiry Date", formData.expiryDate)}
              </>
            )}
          </>
        )}

        {/* Qualifications Section */}
        {renderSection(
          "Qualifications & Certificates",
          <>
            {formData.qualificationFiles &&
            formData.qualificationFiles.length > 0 ? (
              formData.qualificationFiles.map((file, index) => (
                <div key={index} className="mb-2">
                  <strong>Certificate {index + 1}:</strong> {file} (attached)
                </div>
              ))
            ) : (
              <div className="mb-2">—</div>
            )}
          </>
        )}

        {/* Bank Details Section */}
        {renderSection(
          "Bank Account Information",
          <>
            {renderField("Bank Name", formData.bankName)}
            {renderField("Account Holder", formData.accountHolder)}
            {renderField("Sort Code", formData.sortCode)}
            {renderField(
              "Account Number",
              formData.accountNumber
                ? "••••" + formData.accountNumber.slice(-4)
                : "—"
            )}
            {renderField(
              "National Insurance Number",
              formData.nationalInsurance
            )}
          </>
        )}

        {/* Tax Information Section */}
        {renderSection(
          "Tax Information",
          <>
            {renderField("Has P45", formData.hasP45 === "yes" ? "Yes" : "No")}
            {formData.hasP45 === "yes" &&
              renderField("P45 Document", formData.p45File, true)}
            {formData.hasP45 === "no" &&
              renderField("Tax Code", formData.taxCode)}
            {renderField(
              "Student Loan",
              formData.hasStudentLoan === "yes" ? "Yes" : "No"
            )}
            {formData.hasStudentLoan === "yes" &&
              renderField("Loan Details", formData.loanDetails)}
          </>
        )}

        {/* References Section */}
        {renderSection(
          "Professional References",
          <>
            <div className="mb-3">
              <strong>Reference 1:</strong>
              <div className="ms-3 mt-1">
                {renderField("Name", formData.ref1Name)}
                {renderField("Email", formData.ref1Email)}
                {renderField("Mobile", formData.ref1Mobile)}
              </div>
            </div>
            <div className="mb-3">
              <strong>Reference 2:</strong>
              <div className="ms-3 mt-1">
                {renderField("Name", formData.ref2Name)}
                {renderField("Email", formData.ref2Email)}
                {renderField("Mobile", formData.ref2Mobile)}
              </div>
            </div>
          </>
        )}
      </div>

      <div className="alert alert-info mt-4">
        <strong>Please review all information carefully.</strong> Once
        submitted, you cannot make changes to this application.
      </div>

      <div className="text-end mt-5">
        <button
          className="btn btn-dark px-4"
          onClick={() => onNext({})}
          disabled={isCurrentlySubmitting}
        >
          {isCurrentlySubmitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Submitting...
            </>
          ) : (
            "Final Submit"
          )}
        </button>
      </div>
    </div>
  );
}

export default StepFourteen;
